import Vue from 'vue'

Vue.filter('money', (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  }).format(value)
})

Vue.filter('integer', (value) => {
  return parseInt(value, 10)
})

Vue.filter('limit', (value, size) => {
  if (!value) return ''
  if (value.length < size) return value
  return value.substring(0, size) + '...'
})

Vue.filter('time', (value, full = true) => {
  if (!value || value === '') return '- -'
  if (full) {
    return window.moment(value, 'DD/MM/YYYY H:m:s').calendar(null, {
      sameDay: '[Hoje] [às] HH:mm',
      nextDay: '[Amanhã] [às] HH:mm',
      nextWeek: 'DD/MM/YY [às] HH:mm',
      lastDay: '[Ontem] [às] HH:mm',
      lastWeek: 'DD/MM/YY [às] HH:mm',
      sameElse: 'DD/MM/YY [às] HH:mm'
    })
  } else {
    return window.moment(value, 'DD/MM/YYYY').calendar(null, {
      sameDay: '[Hoje]',
      nextDay: '[Amanhã]',
      nextWeek: 'DD/MM/YY',
      lastDay: '[Ontem]',
      lastWeek: 'DD/MM/YY',
      sameElse: 'DD/MM/YY'
    })
  }
})

Vue.filter('br2nl', (value) => {
  if (!value) return ''
  return value.replace(/<br\s*\/?>/mg, '\n')
})

Vue.filter('nl2br', (value) => {
  if (!value) return ''
  return value.replace(/(\r\n|\n\r|\r|\n)/g, '<br>')
})



// WEBPACK FOOTER //
// ./src/filters.js